// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'tiny... Remove this comment to see the full error message
import tinymce from 'tinymce';
/* There are cases where consumers wish to trigger editor events
 * from outside of the toolbar. We don't want consumers to have
 * to worry about TinyMCE internals such as event names, so we
 * export these wrappers that abstract away such details and
 * only require an editor instance.
 */

const ensureEditorIsSelected = editor => {
  const isActiveEditor = tinymce.activeEditor.id === editor.id;
  if (!isActiveEditor) {
    const editorEl = editor.bodyElement;
    if (!editorEl.hasChildNodes()) {
      editor.selection.select(editorEl);
      editor.selection.collapse();
    } else {
      const editorChildren = editorEl.childNodes;
      const lastContentNode = editorChildren[editorChildren.length - 1];
      editor.selection.select(lastContentNode);
      editor.selection.collapse();
    }
  }
};
export const openEmojiPicker = editor => {
  if (editor) {
    ensureEditorIsSelected(editor);
    editor.fire('OpenEmojiPopover');
  } else {
    console.error('[tinymce-config] openEmojiPicker called without editor argument');
  }
};
export const openPersonalizePopover = editor => {
  if (editor) {
    ensureEditorIsSelected(editor);
    editor.fire('OpenPersonalizePopover');
  } else {
    console.error('[tinymce-config] openPersonalizePopover called without editor argument');
  }
};
export const getDecodedContent = editor => {
  return tinymce.html.Entities.decode(editor.getContent());
};
const encode = tinymce.html.Entities.getEncodeFunc('named');
export const getEncodedValue = value => {
  return encode(value);
};